import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {BonusBunniesParsedGameData} from "../../server/data/BonusBunniesParsedGameData";
import {BonusBunniesGameMode} from "../../gamemode/BonusBunniesGameMode";
import {BonusBunniesValueSymbolReplacerView} from "./BonusBunniesValueSymbolReplacerView";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {BonusBunniesGameModuleConfig} from "../../BonusBunniesGameModuleConfig";

/**
 * Created by Jerker Nord on 2019-11-15.
 */

export class BonusBunniesValueSymbolReplacerController extends ReelStopPresentationController {

    private _lastReelActivated:boolean;
    private _bottomRowActivated:boolean;
    private _view:BonusBunniesValueSymbolReplacerView;
    private _orginalReels:string[][];

    constructor(index:number) {
        super(index, "BonusBunniesValueSymbolReplacerController");
        this._view = BonusBunniesGameModuleConfig.bonusBunniesValueSymbolReplacerView = new BonusBunniesValueSymbolReplacerView(ResourcesGroupName.MAIN);
    }

    protected parseFeatureGameData(data:BonusBunniesParsedGameData):void {
        if(data.mode == BonusBunniesGameMode.BONUS_GAME || data.nextMode == BonusBunniesGameMode.BONUS_GAME) {
            this._lastReelActivated = data.lastReelActivated;
            this._bottomRowActivated = data.bottomRowActivated;
            this._orginalReels = data.orginalReels;
        }
    }

    public onReelBounce(data:IReelStoppedData):void {
        if(this._gameData!.mode == BonusBunniesGameMode.BONUS_GAME) {
            if(this._gameData!.reels[data.reelId][1] !== "X") {
                BonusBunniesGameModuleConfig.bonusBunniesSpinController.disableBonusReel(data.reelId);
                if(this._gameData!.reels[data.reelId][1].indexOf("V") > -1) {
                    this._view.playVSymbolAttention(data.reelId);
                } else if(this._gameData!.reels[data.reelId][1] == "B2") {
                    this._view.activateB2Symbol(data.reelId);
                } else if(this._gameData!.reels[data.reelId][1].indexOf("B3") > -1) {
                    this._view.activateB3Symbol(data.reelId);
                } else if(this._gameData!.reels[data.reelId][1].indexOf("B4") > -1) {
                    this._view.activateB4Symbol(data.reelId);
                }
            }
        }
    }

    public onReelSpinStopped(data:IReelStoppedData):void {
        if(this._gameData!.mode == BonusBunniesGameMode.BONUS_GAME) {
            if(this._gameData!.reels[data.reelId][1] !== "X") {
                BonusBunniesGameModuleConfig.bonusBunniesSpinController.disableBonusReel(data.reelId);
            }
        }
        this.dispatchCompleteEvent(data.reelId);
    }
}